import { gsap } from "gsap/dist/gsap";
    
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const block = document.querySelector(".c-parallax-block");

const list = document.querySelector(".parallax-list");

const title = document.querySelector(".parallax-title");

const elements = document.querySelectorAll('.parallax-item');


function parallaxBlocks() {
        // Create a GSAP timeline
        gsap.timeline({

            scrollTrigger: {
                trigger: title,
                start: "top 80%",
            },


        }).addLabel('start')
        .from(title, {duration: 1, ease: 'circ.out', yPercent: 100,}, 'start');


        const tl = gsap.timeline({
            scrollTrigger: {
              trigger: block,
              start: "top top",
              bottom: 'bottom bottom',
              scrub: true,
              pin: '.c-parallax-block-inner',
              pinSpacing: true,
              
            },
          });
          elements.forEach((el, i) => {
            const scale = 0.8;
            tl.to(el, {
              duration: 3,
              ease: 'linear',
              scale: scale + i / 10,
              yPercent: -85 * i
            }, "-=1");
          });


        }


        function setHeight(){

          if(block != undefined){
            block.style.maxHeight =  block.offsetHeight + (list.offsetHeight * 0.75) + 'px';
          }

        }




    if (window.innerWidth >= 788) {
        parallaxBlocks();
        setHeight();

        //window.addEventListener("resize", setHeight);

    }
    
